/**
 * Set a timeout to do some operations to elements inside the checkout block that are normally done
 * on page load. This timeout is necessary because WooCommerce loads the checkout block
 * asynchronously.
 */
(() => {
    let checkout = document.querySelector('.wp-block-woocommerce-checkout');

    if (!checkout) {
        return;
    }

    setTimeout(() => {
        H_Tools?.links?.modifyLinks(checkout);
        H_Tools?.stickyheader?.makeBackwardsFocusable(checkout);
    }, 4000);
})();

/**
 * Replace the payment plugin's hardcoded payment method error message
 * with translated string
 */
(() => {
    const original_message = 'Please select a payment method.';
    const replacement = h_woocommerce_payment_method.payment_method;

    const observer = new MutationObserver(() => {
        document
            .querySelectorAll('.wc-block-components-notice-banner.is-error')
            .forEach((el) => {
                if (el.textContent.includes(original_message)) {
                    el.textContent = el.textContent.replace(
                        original_message,
                        replacement
                    );
                }
            });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
})();
